module.exports = __webpack_public_path__ + "files/7d2d2eb3f46c5b58f333d8a3b664fc54.png";


//////////////////
// WEBPACK FOOTER
// ./images/iphone-6-mockup.png
// module id = 2753
// module chunks = 12